import React from "react";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "@folio/stripes/components";
import { PublisherPrefixHistoryTable } from "./PublisherPrefixHistoryTable";
import { PublisherGenericProductNumbersTable } from "./PublisherGenericProductNumbersTable";
import { usePublisherPrefixHistoryData } from "../hooks/usePublisherPrefixHistoryData";
import { usePublisherGenericProductNumbersData } from "../hooks/usePublisherGenericProductNumbersData";
export var PublisherPrefixHistorySection = function (_a) {
    var publisherId = _a.publisherId;
    var _b = usePublisherPrefixHistoryData(publisherId), prefixHistoryData = _b.prefixHistoryData, prefixHistoryLoading = _b.isLoading;
    var _c = usePublisherGenericProductNumbersData(publisherId), genericProductNumbersData = _c.genericProductNumbersData, genericProductNumbersLoading = _c.isLoading;
    if (prefixHistoryLoading || genericProductNumbersLoading) {
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    if (prefixHistoryData.length === 0 &&
        genericProductNumbersData.length === 0) {
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(FormattedMessage, { id: "ui-br-agency.publisher.prefixHistory.noData" }))));
    }
    return (React.createElement(Row, null,
        genericProductNumbersData.length > 0 && (React.createElement(Col, { xs: 12 },
            React.createElement(PublisherGenericProductNumbersTable, { numbers: genericProductNumbersData }))),
        prefixHistoryData.length > 0 && (React.createElement(Col, { xs: 12 },
            React.createElement(PublisherPrefixHistoryTable, { prefixes: prefixHistoryData })))));
};
